var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "vuequilleditorone" },
    [
      _c("editor-bar", {
        attrs: { editorData: _vm.editorDataList },
        on: { input: _vm.inputchange },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }